import {
    HouseIcon,
    PaperListIcon,
    PaperListSparklesAiIcon,
    RecipeIcon,
    ShoppingBasketIcon,
} from '@coop/icons';

import type { ProfilePopoverItem } from './HeaderProfilePopover.types';

import { appConfig } from '../../../../../appConfig';

export const b2cLinks: ProfilePopoverItem[] = [
    {
        id: 'savedCart',
        type: 'link',
        name: 'Sparade varukorgar',
        url: appConfig.coopSettings.myCoop.savedCartListUrl,
        icon: <ShoppingBasketIcon />,
    },
    {
        id: 'shoppingList',
        type: 'link',
        name: 'Sparade inköpslistor',
        url: appConfig.coopSettings.myCoop.shoppingListPageUrl,
        icon: <PaperListIcon />,
    },
    {
        id: 'smartShoppingList',
        type: 'link',
        name: 'Smarta inköpslistor',
        url: appConfig.coopSettings.myCoop.shoppingListPageUrl,
        icon: <PaperListSparklesAiIcon />,
    },
    {
        id: 'favoriteRecipes',
        type: 'link',
        name: 'Sparade recept',
        url: appConfig.coopSettings.myCoop.savedRecipesPageUrl,
        icon: <RecipeIcon />,
    },
    {
        id: 'favoriteStores',
        type: 'link',
        name: 'Sparade butiker',
        url: appConfig.coopSettings.stores.mapStorePageUrl,
        icon: <HouseIcon />,
    },
] as const;

export const b2bLinks: ProfilePopoverItem[] = [
    {
        id: 'savedCart',
        type: 'link',
        name: 'Sparade varukorgar',
        url: appConfig.coopSettings.myCoop.savedCartListUrl,
        icon: <ShoppingBasketIcon />,
    },
    {
        id: 'shoppingList',
        type: 'link',
        name: 'Sparade inköpslistor',
        url: appConfig.coopSettings.myCoop.shoppingListPageUrl,
        icon: <PaperListIcon />,
    },
    {
        id: 'smartShoppingList',
        type: 'link',
        name: 'Smarta inköpslistor',
        url: appConfig.coopSettings.myCoop.shoppingListPageUrl,
        icon: <PaperListSparklesAiIcon />,
    },
] as const;
